<template>
    <div class="headerBox">

            <div class="visible-xs-block visible-sm-block">
                <div class="header" style="height: 60px">
                <div style="text-align: center; margin: 0px -30px;">
                    <img src="../../assets/images/logo.png" alt="" style="margin-top: 20px" height="40px">
                </div>
                </div>
            </div>
        <!--<div class="visible-md-block visible-lg-block">-->
            <!--<div class="header" style="display:flex;justify-content: space-between">-->
                <!--<div>-->
                    <!--<img src="../../assets/images/logo.png" alt="" style="margin-top: 20px" height="40px">-->
                <!--</div>-->
                <!--<div>-->
                    <!--<div class="menu">-->
                        <!--&lt;!&ndash;<span v-for="(item,index) in menuList" :key="index"><router-link :to="item.path" :style="item.path == currentPath?'color:#ffff':''">{{ $t(item.name) }}</router-link></span>&ndash;&gt;-->
                        <!--<span v-for="(item,index) in menuList" :key="index" @click="gotoWeizhi(item.id)" :style="item.id == activeId?'color:#fff':''">{{ $t(item.name) }}</span>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div style="margin: 27px -8px 0 0;">-->
                    <!--<span @click="changeLang('zh-CN')">中</span>-->
                    <!--<span> | </span>-->
                    <!--<span @click="changeLang('en-US')">EN</span>-->
                    <!--&lt;!&ndash;<span> | </span>&ndash;&gt;-->
                    <!--&lt;!&ndash;<span @click="">AR</span>&ndash;&gt;-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
            <div class="visible-md-block visible-lg-block">
                <div class="header">
                <div class="fl">
                    <img src="../../assets/images/logo.png" alt="" style="margin-top: 20px" height="40px">
                </div>
                <div class="fr" style="margin: 27px -8px 0 0;">
                    <span @click="changeLang('zh-CN')">中</span>
                    <span> | </span>
                    <span @click="changeLang('en-US')">EN</span>
                    <!--<span> | </span>-->
                    <!--<span @click="">AR</span>-->
                </div>
                <div style="display: inline-block;margin-left: 40px;">
                    <div class="menu">
                        <!--<span v-for="(item,index) in menuList" :key="index"><router-link :to="item.path" :style="item.path == currentPath?'color:#ffff':''">{{ $t(item.name) }}</router-link></span>-->
                        <span v-for="(item,index) in menuList" :key="index" @click="gotoWeizhi(item.id)" :style="item.id == activeId?'color:#fff':''">{{ $t(item.name) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "headerBox",
        methods: {
            changeLang(lang) {
                this.$i18n.locale = lang;
                localStorage.lang = lang;
            },
            gotoWeizhi(id){
                if(this.$route.path == '/home'){
                    this.move(id);
                }else{
                    this.$router.push('/home')
                }
            },
            move(id){
                this.activeId = id;
                let jump = document.querySelector("#"+id);//定义起跳点div
                let total = jump.offsetTop;
                let distance =
                    document.documentElement.scrollTop || document.body.scrollTop;
                // 平滑滚动，时长500ms，每10ms一跳，共50跳
                let step = total / 80;
                if (total > distance) {
                    smoothDown();
                } else {
                    let newTotal = distance - total;
                    step = newTotal / 80;
                    smoothUp();
                }
                function smoothDown() {
                    if (distance < total) {
                        distance += step;
                        document.body.scrollTop = distance;
                        document.documentElement.scrollTop = distance;
                        setTimeout(smoothDown, 10);
                    } else {
                        document.body.scrollTop = total;
                        document.documentElement.scrollTop = total;
                    }
                }
                function smoothUp() {
                    if (distance > total) {
                        distance -= step;
                        document.body.scrollTop = distance;
                        document.documentElement.scrollTop = distance;
                        setTimeout(smoothUp, 10);
                    } else {
                        document.body.scrollTop = total;
                        document.documentElement.scrollTop = total;
                    }
                }
            },
            handleScroll(){
                if(this.$route.path == '/home'){
                    let top = document.documentElement.scrollTop;
                    if(top<500){
                        this.activeId = 'home'
                    }else if(top>=500&&top<1100){
                        this.activeId = 'about'
                    }else if(top>=1100&&top<1700){
                        this.activeId = 'product'
                    }else if(top>=1700){
                        this.activeId = 'contactUs'
                    }
                }
            }
        },
        watch: {
            '$route':function (to) {
                this.currentPath = to.path;
                if(this.currentPath == '/home'){
                    window.addEventListener('scroll',this.handleScroll) // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
                }else if(this.currentPath == '/game'||this.currentPath == '/business'){
                    this.activeId = 'product';
                    window.removeEventListener('scroll')
                }
            },
        },
        data() {
            return {
                currentPath: this.$route.path,
                activeId:'home',
                menuList: [{
                    path:'/home',
                    name:'lang.header.home',
                    id:'home'
                },{
                    path:'/about',
                    name:'lang.header.aboutUs',
                    id:'about'
                },{
                    path:'/about',
                    name:'lang.header.service',
                    id:'product'
                },{
                    path:'/about',
                    name:'lang.header.concatUs',
                    id:'contactUs'
                }]
            }
        },
        mounted(){

        }
    }
</script>

<style>
    .headerBox{
        height: 80px;
        background: #000;
        position: fixed;
        width: 100%;
        top: 0;
        z-index: 2;
    }
    .headerBox .header{
        width: 80%;
        padding: 0 20px;
        margin: 0 auto;
        color: #fff;
        cursor: pointer;
        font-size: 16px;
    }
    .headerBox .header .menu{
        padding: 29px 0;
        display: inline-block;
        /*margin-left: 20px;*/
    }
    .headerBox .header .menu span{
        padding: 29px 0;
        margin-left: 20px;
        margin-right: 20px;
        color: #8A8A8A;
        font-weight: bold;
    }
    .headerBox .header .menu span:last-child{
        margin-right: 0px;
    }
    /*.headerBox .header .menu span a{*/
        /*color: #8A8A8A;*/
        /*margin-right: 50px;*/
    /*}*/
    /*.headerBox .header .menu span:last-child a{*/
        /*margin-right: 0px;*/
    /*}*/
</style>


// WEBPACK FOOTER //
// src/components/views/headerBox.vue